import React from 'react';
import { DSTextBox, DSComboBox } from '@elliemae/ds-legacy-form';

const FieldControllerRow = ({
  className = '',
  onChange = () => null,
  options = [],
  value = '',
  type = 'DSComboBox',
}) => (
  <div className={className}>
    {type === 'DSComboBox' && <DSComboBox onChange={onChange} options={options} value={value} />}
    {type === 'DSTextBox' && <DSTextBox fluidWidth onChange={onChange} options={options} value={value} />}
  </div>
);
export default FieldControllerRow;
